<div style="padding: 10px 8px 10px 8px">
  <span class="span-title"
    ><b>{{ title }}</b></span
  >
  <div class="pref-message">
    Select filters to visualize the recommendations.The filters selected below will always be removed from the
    recommendations
  </div>
</div>

<!-- <div class="cancel-button" (click)="cancelButton()">
    <ion-icon name="close-outline"></ion-icon>
  </div> -->

<div class="card-content">
  <ng-container *ngFor="let data of customerFiltersForDisplay; let i = index">
    <ng-container *ngIf="data.filter_key === 'highLevelTc'">
      <div class="data-switch">
        <h3>CR</h3>
        <ion-toggle
          [value]="getFilterValues(data.filter_key) || ['FSOP']"
          [checked]="isEqualArray(getFilterValues(data.filter_key) || ['FSOP'], ['FSOP'])"
          aria-label="Enable Notifications"
          (ionChange)="onFilterChange(data.filter_key, $event.detail.checked ? ['FSOP'] : ['CR'], data.filter_type)"
        >
        </ion-toggle>
        <h3>FSOP</h3>
      </div>
    </ng-container>
  </ng-container>
  <div class="scrollable-form-container">
    <form class="card-form">
      <!-- Customers Filters Section -->
      <div class="section">
        <span class="filter-type-name">Customers Filters</span>
        <div class="grid">
          <ng-container *ngFor="let data of customerFiltersForDisplay; let i = index">
            <ng-container *ngIf="data.filter_key !== 'highLevelTc'">
              <app-nbs-select-dropdown
                class="filter"
                [value]="getFilterValues(data.filter_key)"
                [multiSelect]="true"
                label="{{ data.filter_display_name }}"
                [searchable]="true"
                [enableClearAll]="true"
                [options]="data.default_options"
                (selectedItemChange)="onFilterChange(data.filter_key, $event, data)"
              >
              </app-nbs-select-dropdown>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <div class="section">
        <span class="filter-type-name">Material Filters</span>
        <div class="grid">
          <ng-container *ngFor="let data of materialFiltersForDisplay; let i = index">
            <app-nbs-select-dropdown
              class="filter"
              [value]="getFilterValues(data.filter_key)"
              [multiSelect]="true"
              label="{{ data.filter_display_name }}"
              [searchable]="true"
              [enableClearAll]="true"
              [options]="data.default_options"
              (selectedItemChange)="onFilterChange(data.filter_key, $event, data)"
            >
            </app-nbs-select-dropdown>
          </ng-container>
        </div>
      </div>

      <!-- Apply Button -->
      <div class="buttons-container">
        <ion-button class="card-button" [disabled]="isButtonDisabled() || loading" (click)="applyFilters()">
          <ion-spinner *ngIf="loading" name="circular" color="primary"></ion-spinner>
          <span>{{ loading ? "Applying Preferences.." : "Save Preferences" }}</span>
        </ion-button>
      </div>
    </form>
  </div>
</div>
